import { Turbo } from "@hotwired/turbo-rails";
import "./controllers";
import "./channels";

// Show the Turbo progress bar immediately on navigation (default is 500ms delay)
Turbo.config.drive.progressBarDelay = 0;

// Disable Turbo prefetching globally
document.addEventListener("turbo:before-prefetch", function (event) {
  event.preventDefault();
});

import "./archipelago/entry"
